import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.colors.background3,
    padding: `${theme.spacing.space16}px ${theme.spacing.space12}px`,
    borderRadius: theme.radius.small,
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space12,
  },
  itemImg: {
    height: 48,
    width: 48,
    objectFit: "cover",
  },
  coinImg: {
    height: 24,
    width: 24,
  },
  coinItem: {
    gap: theme.spacing.space4,
  },
}));
